import { FileInput, FileInputProps } from '@/components/atoms/FileInput';
import { File } from '@/components/atoms/FileUpload/File';
import { SvgIcon } from '@/components/SvgIcon';

import { Text } from '../Text';

import iconAttachmentSrc from '~/svg/IconCodeFile.svg';

export interface FileUploadProps extends FileInputProps {
  label: React.ReactNode | string;
  disclaimer?: React.ReactNode | string;
  value: File[];
  onChange: (files: File[]) => void;
  onFileRemove: (file: File, index: number) => void;
  classNames?: {
    root?: string;
    input?: FileInputProps['classNames'];
  };
}

export const FileUpload = ({
  label,
  disclaimer,
  value,
  onChange,
  onFileRemove,
  classNames,
  ...rest
}: FileUploadProps) => {
  return (
    <div className={classNames?.root}>
      <FileInput
        {...rest}
        value={value}
        classNames={classNames?.input}
        onChange={onChange}
      >
        <div className='p-2 flex flex-col'>
          <span className='pb-1'>
            <SvgIcon src={iconAttachmentSrc} className='mr-1' />
            {label}
          </span>

          {disclaimer && (
            <Text
              variant='label-text-l'
              classNames={{ wrapper: 'text-gray-400' }}
            >
              {disclaimer}
            </Text>
          )}
        </div>
      </FileInput>

      {value.length > 0 && (
        <ul>
          {value.map((file, i) => (
            <li key={file.name + i}>
              <File file={file} onRemove={() => onFileRemove(file, i)} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
